// Modules
import { useState } from "react"
import { useNavigate } from "react-router-dom"

// Constants
import PATHS from "~constants/paths"
import { APP_VERSION } from "~constants/config"

// Components
import Logo from "~components/Logo"
import ResetCodeForm from "~components/password-reset/ResetCode"
import ResetPasswordForm from "~components/password-reset/ResetPassword"
import {
  AuthLink,
  AuthLayout,
  AuthContainer,
  AuthVersionBadge,
} from "~styled/auth"

// Custom Hooks
import usePublicPath from "~hooks/usePublicPath"

const ForgotPasswordPage = () => {
  const navigate = useNavigate()

  // Using custom hooks
  const loggedIn = usePublicPath()

  // Set component state
  const [username, setUsername] = useState<string>(null!)

  // Method to handle first step
  const handleFirstStep = (username: string) => {
    setUsername(username)
  }

  // Method to redirect to the login
  const redirectToLogin = (event: React.MouseEvent) => {
    event.preventDefault()
    navigate(PATHS.login)
  }

  return (
    !loggedIn && (
      <AuthLayout>
        <AuthContainer>
          <Logo />

          {/* First Step */}
          {!username && <ResetPasswordForm handler={handleFirstStep} />}

          {/* Second Step */}
          {username && <ResetCodeForm username={username} />}

          <AuthLink onClick={redirectToLogin}>Login</AuthLink>
          <AuthVersionBadge>{APP_VERSION}</AuthVersionBadge>
        </AuthContainer>
      </AuthLayout>
    )
  )
}

export default ForgotPasswordPage
